module.exports = __webpack_public_path__ + "0e278c5f10e3fb59cb465a18520e63af.fbx";